import type { LocalizedText } from './types'

/**
 * Локализованное имя из RVF: запрошенный язык → en → default_language венью →
 * первое имеющееся. Пустая строка не возвращается, если есть хоть что-то.
 */
export function localized(
  text: LocalizedText | undefined,
  lang: string,
  venueDefault?: string,
): string {
  if (!text) return ''
  const direct = text[lang]
  if (direct) return direct
  const english = text['en']
  if (english) return english
  if (venueDefault) {
    const byDefault = text[venueDefault]
    if (byDefault) return byDefault
  }
  for (const value of Object.values(text)) {
    if (value) return value
  }
  return ''
}
